import Loader from "../Loader";
import { useState } from "react";
import NoDataDiv from "../NoDataDiv";
import Stack from "@mui/material/Stack";
import { CardTitle } from "../../theme/texts";
import { useQuery } from "@tanstack/react-query";
import ToggleButton from "../../buttons/ToggleButton";
import { useAuth } from "../../../context/AuthContext";
import WeeklyLeaderboardRow from "./WeeklyLeaderboardRow";
import useScreenSize from "../../../context/ScreenContext";
import { getWorkoutLeaderboard } from "../../../api/workouts";
import {
  SpacedRow,
  MainText,
  AllCenteredColumn,
} from "../../../data/style/Style";

const WeeklyLeaderBoard = (props) => {
  let { workoutId, level } = props;
  const { profile } = useAuth();
  const [gender, setGender] = useState(profile.gender);
  const { mobileDevice } = useScreenSize();

  const { data, isPending } = useQuery({
    queryKey: [
      "weekly",
      "workout",
      "leaderboard",
      "level",
      level,
      gender === 0 ? "male" : "female",
    ],
    queryFn: ({ signal }) =>
      getWorkoutLeaderboard({ workoutId, gender, signal }),
  });

  const GENDERS = [
    {
      id: 0,
      label: "♂ Male",
    },
    {
      id: 1,
      label: "♀ Female",
    },
  ];
  
  return (
    <>
      <SpacedRow>
        <CardTitle
          subTitle={"Leaderboard"}
          mainTitle={`Top ${gender === 0 ? "Males" : "Females"}`}
          isMobile={mobileDevice}
        />
        <ToggleButton items={GENDERS} setId={setGender} id={gender} />
      </SpacedRow>
      {workoutId !== 0 ? (
        <>
          {!isPending ? (
            <Stack mt={2} gap={1} alignItems={"center"} minHeight={"300px"}>
              {data.length !== 0 ? (
                <>
                  {data.map((item, index) => (
                    <WeeklyLeaderboardRow
                      key={index}
                      index={index}
                      item={item}
                      gender={gender}
                    />
                  ))}
                </>
              ) : (
                <NoDataDiv
                  minHeight={"300px"}
                  header={"No scores yet."}
                  text={"Be the first to submit."}
                />
              )}
            </Stack>
          ) : (
            <Loader />
          )}
        </>
      ) : (
        <AllCenteredColumn minHeight={"300px"}>
          <MainText>Next workout generating soon…</MainText>
        </AllCenteredColumn>
      )}
    </>
  );
};

export default WeeklyLeaderBoard;
